import {
  DesktopArtifactArch,
  DesktopArtifactPlatform,
  DesktopDistribution,
  type DesktopUpdateManifestResponse,
} from "@packages/global";
import { httpClient } from "./httpClient";

export interface DesktopDownloadTarget {
  platform: DesktopArtifactPlatform;
  arch: DesktopArtifactArch;
  distribution: DesktopDistribution;
}

export class DesktopReleaseApi {
  async manifest(
    target: DesktopDownloadTarget,
    currentVersion = "0.0.0",
  ): Promise<DesktopUpdateManifestResponse | null> {
    return httpClient.get<DesktopUpdateManifestResponse | null>(
      "/desktop/updates/manifest",
      { ...target, currentVersion },
    );
  }
}

export const desktopReleaseApi = new DesktopReleaseApi();
